import { ReasonForExecutorship } from '/@/modules/estateaccount/models/meta/constants/ReasonForExecutorship';

export class ExecutorAccountMeta {
  relationshipType?: string;

  otherRelationshipType?: string;

  isNextOfKin?: boolean;

  reasonForExecutorship?: string;

  reasonForExecutorshipOtherExplanation?: string;

  isAppointedInWill?: boolean;

  hasOnboarded?: string;

  willActAsPersonalRepresentative?: boolean;

  requiresConsent?: boolean;

  isAftercareOnly?: boolean;

  constructor(model: Partial<ExecutorAccountMeta> = {}) {
    this.relationshipType = model.relationshipType;
    this.otherRelationshipType = model.otherRelationshipType;
    this.isNextOfKin = model.isNextOfKin;
    this.reasonForExecutorship = model.reasonForExecutorship;
    this.reasonForExecutorshipOtherExplanation = model.reasonForExecutorshipOtherExplanation;
    this.isAppointedInWill = model.isAppointedInWill;
    this.hasOnboarded = model.hasOnboarded;
    this.willActAsPersonalRepresentative = model.willActAsPersonalRepresentative;
    this.requiresConsent = model.requiresConsent;
    this.isAftercareOnly = model.isAftercareOnly;
  }

  get isReasonForExecutorshipOther(): boolean {
    return this.reasonForExecutorship === ReasonForExecutorship.OTHER.key;
  }

  get isReasonForExecutorshipDeath(): boolean {
    return this.reasonForExecutorship === ReasonForExecutorship.DEATH.key;
  }

  get isReasonForExecutorshipRenunciation(): boolean {
    return this.reasonForExecutorship === ReasonForExecutorship.RENUNCIATION.key;
  }
}
